import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesCrossedOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m2.64 1.645-.003.001L1.495.505l-.99.99 1.007 1.007C.692 3.53.5 5.226.5 8c0 6.125.938 7 7.5 7 2.54 0 4.237-.131 5.363-.647L14.51 15.5l.99-.995-2.012-2.013-6.463-6.459h.004l-1.4-1.4h-.004L3.729 2.738h.004zm-.519 2.954c.106-.521.242-.86.393-1.095L4 4.99v1.043h1.043L6.31 7.3H4v1.4h3.33v-.38l4.941 4.941a6 6 0 0 1-.573.128c-.882.155-2.067.21-3.698.21s-2.816-.055-3.698-.21c-.875-.154-1.307-.382-1.558-.616-.24-.223-.466-.596-.623-1.373-.16-.797-.221-1.88-.221-3.4s.06-2.604.221-3.4"
                        fill="currentColor"
                    />
                    <path d="m7.61 4.633 1.401 1.4H12v-1.4z" fill="currentColor" />
                    <path
                        d="M13.952 10.972c.106-.747.148-1.709.148-2.972 0-1.52-.06-2.604-.221-3.4-.157-.777-.384-1.15-.623-1.374-.25-.233-.683-.461-1.558-.615C10.816 2.456 9.631 2.4 8 2.4c-1.009 0-1.847.021-2.549.074L4.187 1.211C5.177 1.05 6.427 1 8 1c6.563 0 7.5.875 7.5 7 0 1.803-.081 3.152-.364 4.156z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
CardLinesCrossedOutlinedSize16Glyph.displayName = 'CardLinesCrossedOutlinedSize16Glyph';
